import React from 'react';
import { Grid, TextField } from '../../ui';
const DialogCustomerInput = ({ vCustomerData, setVcustomerData }) => {


    return (
        <div className="billing-cust-input-data">
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <TextField id="outlined-basic" label="Customer Name" variant="filled" size="small" required
                        value={vCustomerData.custName}
                        onChange={e => setVcustomerData(prev => ({ ...prev, custName: e.target.value }))} sx={{ width: "100%" }} />
                </Grid><Grid item xs={12}>
                    <TextField id="outlined-basic" label="Customer Mobile Number" variant="filled" size="small"
                        disabled={vCustomerData.custMob.length > 0} required value={vCustomerData.custMob}
                        onChange={e => setVcustomerData(prev => ({ ...prev, custMob: e.target.value }))} sx={{ width: "100%" }} />
                </Grid><Grid item xs={12}>
                    <TextField id="outlined-basic" label="Customer Email Address"
                        variant="filled" size="small" value={vCustomerData.custEmail}
                        onChange={e => setVcustomerData(prev => ({ ...prev, custEmail: e.target.value }))} sx={{ width: "100%" }} />
                </Grid><Grid item xs={12}>
                    <TextField id="outlined-basic"
                        label="Customer Address"
                        variant="filled" size="small"
                        value={vCustomerData.address}
                        onChange={e => setVcustomerData(prev => ({ ...prev, address: e.target.value }))} sx={{ width: "100%" }} />
                </Grid><Grid item xs={12}>
                    <TextField id="outlined-basic"
                        label="Customer GST Details" variant="filled" size="small"
                        value={vCustomerData.custGstDetails}
                        onChange={e => setVcustomerData(prev => ({ ...prev, custGstDetails: e.target.value }))} sx={{ width: "100%" }} />
                </Grid><Grid item xs={12}>
                    <TextField id="outlined-basic"
                        label="Customer Company Details"
                        variant="filled" size="small"
                        value={vCustomerData.custCompanyName}
                        onChange={e => setVcustomerData(prev => ({ ...prev, custCompanyName: e.target.value }))} sx={{ width: "100%" }} />
                </Grid></Grid>
        </div>
    )
};

export default React.memo(DialogCustomerInput);